export const ROUTE_CONSTANTS = {
  BASE: '/',
  DASHBOARD: 'dashboard',
  DASHBOARD_AGENCY: 'dashboard/agency',
  DASHBOARD_AGENCY_EDIT: 'dashboard/edit/agency',
  JOB_ORDERS: 'jobs',
  JOB_ORDER_DETAIL: 'jobs/:id',
  JOB_ORDER_CREATE: '/jobs/create',
  JOB_ORDER_CREATE_BULK_DAY: '/jobs/createBulkDay',
  JOB_ORDER_CREATE_RECURRING: '/jobs/createRecurring',
  CORPORATIONS: 'corporations/corporationList',
  CORPORATION_CREATE: 'corporations/createCorporation',
  USERS_V2: 'users',
  USERS_V2_ACTIVE_WORKER: '/users/?role=candidate&loginsort=desc&status=active',
  USERS_V2_PENDING_ONBOARDING: '/users/?role=candidate&loginsort=desc&status=onboardingIncomplete',
  USERS_V2_WAITING_VERIFICATION: '/users/?role=candidate&loginsort=desc&status=unverified',
  USERS_V2_DETAIL: 'users/:id',
  POSITION_TEMPLATES: 'jobs/positionTemplateList',
  POSITION_TEMPLATE_CREATE: 'positionTemplates/create',
  POSITION_TEMPLATE_DETAIL: 'positionTemplates/:id',
  TIMEKEEPING: 'timekeeping',
  REGISTER: 'register',
  REPORTING: 'reporting',
  SETTINGS: 'settings',
  FORGOT_MY_PASSWORD: 'forgotMyPassword',
  PASSWORD_RESET_QUERY_INFORMATION: 'passwordReset/:queryinformation',
  SKILLS_AND_CERTS: 'skillsAndCerts',
  ACCOUNT_VERIFICATION_QUERY_INFORMATION: 'accountverification/:queryinformation',
  CANDIDATE_REDIRECT: 'candidate',
  AGENCY_CREATE: 'agencies/create',
  TIMECARD_HISTORY: 'timekeeping/history/:id',
  CONTRACT_CREATE: 'users/:userId/:contractType/contracts/create',
};

export const searchParamOptions = {
  // ALL THESE ARE TEXT OF THE VALUE - not truly number/boolean
  EMPLOYEE: 'employee',
  PLACEMENT: 'placement', // ID
  WEEK_START: 'weekStart', // number (epoch)
  ACTIVE_TAB: 'activeTab', // number (index of array)
  JOB_TYPE: 'jobType', // 'long' || 'day' || 'both
  JOB_ORDER: 'jobOrder', // ID
  CANDIDATE: 'candidate', // ID
  SELECTED_DATE: 'selectedDate', // number (epoch)
  LOCATION: 'location', // ID
  SHIFT_GROUP: 'shiftGroup', // ID
  POSITION: 'positionTemplate', // ID
  INVITED: 'isInvite', // 'true || 'false'
  START_DATE: 'startDate', // epoch
  END_DATE: 'endDate', // epoch
};
